import { fetcher } from '@commenda/utils';

/** Repeating it changes nothing. */
const enableSalesTax = async (businessEntityId: number) => {
  return fetcher(`business-entities/${businessEntityId}/sales-tax`, {
    method: 'PUT',
  });
};

export { enableSalesTax };
